import { AfterViewInit, Component, inject } from '@angular/core';
import { BaseListComponent } from '../base-list/base-list.component';
import { MenuItem, MessageService } from 'primeng/api';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { RoutingService } from '../../../services/routing.service';
import { Story } from '../../../models/story';
import { StoryStore } from '../../../stores/story/story.state';
import { SidebarModule } from 'primeng/sidebar';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../mask/mask.component';
import { TableListActionsComponent } from '../../molecules/table-list-actions/table-list-actions.component';
import { TableModule } from 'primeng/table';
import { TableCaptionComponent } from '../../molecules/table-list-caption/table-list-caption.component';
import { TabMenuModule } from 'primeng/tabmenu';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { NgIf } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { BookmarkCategoryStore } from '../../../stores/bookmark-category/bookmark-category.state';
import { AlertComponent } from '../../atoms/alert/alert.component';

@Component({
  selector: 'app-story-administration',
  standalone: true,
  imports: [
    SidebarModule,
    HeaderComponent,
    RouterOutlet,
    MaskComponent,
    TableListActionsComponent,
    TableModule,
    TableCaptionComponent,
    TabMenuModule,
    NgIf,
    BadgeModule,
    AlertComponent,
  ],
  templateUrl: './story-administration.component.html',
  styleUrl: './story-administration.component.scss',
})
export class StoryAdministrationComponent
  extends BaseListComponent<Story>
  implements AfterViewInit
{
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-8',
    icon: 'fas fa-file-lines',
    headerText: 'Berichte',
  };
  readonly store = inject(StoryStore);
  readonly categoryStore = inject(BookmarkCategoryStore);
  override menuItems: MenuItem[] = [];
  override sidebarId = 'story-administration';

  constructor(
    protected sidebarService: SidebarService,
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );
  }

  /**
   * A lifecycle hook that is called after Angular has fully initialized
   * the component's view and child views. Typically used to perform
   * initialization that requires the component's view to be fully rendered.
   *
   * In this method, the sidebar configuration is set using the sidebar service.
   *
   * @return {void} Does not return a value.
   */
  ngAfterViewInit(): void {
    this.sidebarService.setConfiguration(this.sidebarConfig);
  }
}
